export const SELLERTOAUCTIONEERINVOICE_SEARCH =
  "SELLERTOAUCTIONEERINVOICE_SEARCH";
export const SELLERTOAUCTIONEERINVOICE_SEARCH_SUCCESS =
  "SELLERTOAUCTIONEERINVOICE_SEARCH_SUCCESS";
export const SELLERTOAUCTIONEERINVOICE_SEARCH_FAIL =
  "SELLERTOAUCTIONEERINVOICE_SEARCH_FAIL";

export const SELLERTOAUCTIONEERINVOICE_VIEWINVOICEDETAIL =
  "SELLERTOAUCTIONEERINVOICE_VIEWINVOICEDETAIL";
export const SELLERTOAUCTIONEERINVOICE_VIEWINVOICEDETAIL_SUCCESS =
  "SELLERTOAUCTIONEERINVOICE_VIEWINVOICEDETAIL_SUCCESS";
export const SELLERTOAUCTIONEERINVOICE_VIEWINVOICEDETAIL_FAIL =
  "SELLERTOAUCTIONEERINVOICE_VIEWINVOICEDETAIL_FAIL";

export const SELLERTOAUCTIONEERINVOICE_CREATE =
  "SELLERTOAUCTIONEERINVOICE_CREATE";
export const SELLERTOAUCTIONEERINVOICE_CREATE_SUCCESS =
  "SELLERTOAUCTIONEERINVOICE_CREATE_SUCCESS";
export const SELLERTOAUCTIONEERINVOICE_CREATE_FAIL =
  "SELLERTOAUCTIONEERINVOICE_CREATE_FAIL";

export const API_STATUS_SELLER_TAX = "API_STATUS_SELLER_TAX";


export const ENABLE_GENERATE_INVOICE_BUTTON = 'ENABLE_GENERATE_INVOICE_BUTTON';
export const DISABLE_GENERATE_INVOICE_BUTTON = 'DISABLE_GENERATE_INVOICE_BUTTON';

export const ENABLE_SEARCH_INVOICE_BUTTON = 'ENABLE_SEARCH_INVOICE_BUTTON'
export const DISABLE_SEARCH_INVOICE_BUTTON = 'DISABLE_SEARCH_INVOICE_BUTTON'